<template>
  <div>
    <p class="have-invite-code" :class="showInviteCodeInput ? 'isOpen' : ''">
      <a href="javascript:void(0)" @click="showInviteCodeInput = !showInviteCodeInput">{{ $t('haveInvitationCode') }}</a>
    </p>
    <transition name="slide-fade">
      <div class="form-group invite-code" v-show="showInviteCodeInput">
        <input type="text" :placeholder="$t('inviteCodePlaceholder')" name="invitationCode"
               v-model.trim="invitationCode"
               v-validate="'min:5|max:6'"
               @change="inviteChange"
               @blur="showError.invitationCode = true"
               :class="{'input': true, 'danger-border': errors.has('invitationCode') || !!inviteCodeErrorMessage}">
        <p class="error-info">
          <span v-show="errors.has('invitationCode') && showError.invitationCode">{{ errors.first('invitationCode') }}</span>
          <span v-show="showError.invitationCode">{{ inviteCodeErrorMessage }}</span>
        </p>
      </div>
    </transition>
  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins/button";
  @import "../../assets/scss/formstyle";

  .slide-fade-enter-active {
    transition: all .3s linear;
  }

  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-active {
    transform: translateX(10px);
    opacity: 0;
  }

  .have-invite-code {
    a {
      font-size: 18px;
      color: #999999;
      letter-spacing: 0;
      line-height: .3rem;
      text-decoration: underline;
    }
    &.isOpen a {
      color: #666;
      text-decoration: none;
    }
  }

  div.invite-code {
    input {
      margin-top: .08rem;
      height: .54rem;
      line-height: .54rem;
      border: 1px solid #E0D7E3;
      border-radius: 42px;
      padding: 0 24px;
      font-size: 16px;
      &::placeholder {
        color: #ccc;
      }
    }
  }
  
@media (max-width: 767px) {
  .have-invite-code a {
    font-size: 14px;
    line-height: 14px;
  }
  div.invite-code input {
    height: .49rem;
    line-height: .49rem;
    font-size: 14px;
  }
  .error-info {
    margin-top: 0.02rem;
  }
}
</style>

<script>
  import cookie from '../../lib/cookie'
  import bus from '../../assets/js/Bus'
  import locales from './lang.js'
  export default {
    name: 'invitation-code-view',
    data: function () {
      return {
        invitationCode: '',
        inviteCodeErrorMessage: '',
        inviteLoading: this.$t('inviteLoading'),
        showInviteCodeInput: false,
        showError: {
          'invitationCode': false
        }
      }
    },
    created: function () {
      if (this.$route.query.invite_code) {
        this.showInviteCodeInput = true
        this.invitationCode = this.$route.query.invite_code
        this.$emit('input', this.$route.query.invite_code)
        cookie.setCookie('invite_code', '', -1)
        this.$http.get('api/invitation-code/validate?invitation_code=' + this.$route.query.invite_code).then((response) => {
          if (response.data.code === 0) {
            cookie.setCookie('invite_code', this.$route.query.invite_code, 30)
          } else {
            this.showError.invitationCode = true
            this.inviteCodeErrorMessage = response.data.message
          }
        })
      } else if (cookie.getCookie('invite_code')) {
        this.showInviteCodeInput = true
        this.invitationCode = cookie.getCookie('invite_code')
        this.$emit('input', this.invitationCode)
        this.$http.get('api/invitation-code/validate?invitation_code=' + this.invitationCode).then((response) => {
          if (response.data.code === 0) {
            this.inviteCodeErrorMessage = ''
          } else {
            this.showError.invitationCode = true
            this.inviteCodeErrorMessage = response.data.message
          }
        })
      }
    },
    locales,
    watch: {
      showInviteCodeInput() {
        if (this.showInviteCodeInput) {
          this.$emit('input', this.invitationCode)
          return
        }
        this.$emit('input', '')
      },
      invitationCode() {
        this.showError.invitationCode = false
      }
    },
    methods: {
      inviteChange: function () {
        this.$emit('input', this.invitationCode)
        bus.$emit('errors-changed', this.errors)
        if (this.invitationCode === '') {
          this.inviteCodeErrorMessage = ''
          return
        }
        if (this.errors.has('invitationCode')) {
          return
        }
        this.inviteCodeErrorMessage = this.inviteLoading
        this.$http.get('api/invitation-code/validate?invitation_code=' + this.invitationCode).then((response) => {
          if (response.data.code === 0) {
            this.inviteCodeErrorMessage = ''
          } else {
            this.inviteCodeErrorMessage = response.data.message
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InvitationCode.vue?32c23431